export const TEXTO_SUSPENSAO_PADRAO = `<p>Você pode suspender sua assinatura por 1 mês - e durante esse período continua aproveitando todos os benefícios de associado: acesso ao aplicativo, conteúdos exclusivos e descontos na livraria.</p><br>
  <p>No mês seguinte, sua assinatura é retomada automaticamente e os kits voltam a ser enviados normalmente.</p>`

export const TEXTO_SUSPENSAO_ANUAL = 'Não haverá cobrança referente ao mês de suspensão.'

export const PERGUNTA_MOTIVO = 'Selecione o motivo de suspensão (pausa por um mês)'

export const VALOR_DEFAULT = 'DEFAULT'

export const MOTIVOS_SUSPENSAO = [
  {
    'texto': 'Motivo da suspensão',
    'value': VALOR_DEFAULT
  },
  {
    'texto': 'Financeiro',
    'value': 'F'
  },
  {
    'texto': 'Viagem',
    'value': 'V'
  },
  {
    'texto': 'Já tenho o livro',
    'value': 'JA'
  },
  {
    'texto': 'Não gostei do tema',
    'value': 'TEMA'
  },
  {
    'texto': 'O kit desse mês não me agradou',
    'value': 'NAO_QUER_KIT_DO_MES'
  },
  {
    'texto': 'Sem tempo para ler',
    'value': 'S'
  }
]
